export enum OpenAIAzureModels {
  GPT_4O = "gpt-4o",
  GPT_4_1 = "gpt-4.1"
}

export const OpenAIAzureModelsEnabled = [
  OpenAIAzureModels.GPT_4O,
  OpenAIAzureModels.GPT_4_1,
]

export const OpenAIAzureDedicatedModelsMap: {[key: string]: string} = {
  [OpenAIAzureModels.GPT_4O]: "gpt-4o-dedicated",
}
